import React, { Fragment } from 'react';
import moment from 'moment';
import { Grid } from '@material-ui/core';
import LabelValueCard from './LabelValueCard';
const RevisionEditCard = ({item, dateFormat, showProject = false}) => {
  return(
    <Fragment>
      <Grid container spacing={3}>
        { showProject ?
          <Fragment>
            <LabelValueCard md={6} label='Project Number' value={item?.project_number ? `#${item?.project_number}` : '--'} />
            <LabelValueCard md={6} label='Project Name' value={item?.name || '--'} />
          </Fragment> : null
        }
        <LabelValueCard md={6} label='Updated at' value={dateFormat && item?.timestamp ? moment.utc(item?.timestamp).local().format(dateFormat) : item?.timestamp} />
        <LabelValueCard md={6} label='Updated by' value={item.user && item.user.name ? item.user.name:'--'} />
      </Grid>
      <div className="edit-detail-table">
        <table>
          <thead>
            <tr>
              <th style={{width: '33%'}}>Label</th>
              <th style={{width: '33%'}}>Old Value</th>
              <th style={{width: '33%'}}>New Value</th>
            </tr>
          </thead>
          <tbody>
            { Object.keys(item.changes).map(label =>
              <tr>
                <td>{label}</td>
                <td>{item.changes[label][0]}</td>
                <td>{item.changes[label][1]}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </Fragment>
  )
}
export default RevisionEditCard;
